module.exports = __webpack_public_path__ + "img/switzerland-cerebrovascular-disease-male.ef378043.png";